import request from '../utils/request'

export default {
  // 获取所有
  findAll(params) {
    return request.get('/api/record', { params })
  },

  // 重新发送进行中的最新报文
  pushLatestShootData(imeiList) {
    return request.post(`/api/record/pushLatestShootData`, imeiList)
  },

  // 重新发送进行中的历史报文
  pushHistoryShootData(imei, roundStatus) {
    return request.post(`/api/record/pushHistoryShootData/${imei}/${roundStatus}`)
  },

  // 根据轮次编号重新发送历史报文
  pushShootDataByRoundNo(roundNo, activityId) {
    return request.post(`/api/record/pushShootDataByRoundNo/${roundNo}/${activityId}`)
  },

  // 获取场次内有射击数据的所有设备
  findByActivityIdWithData(activityId) {
    return request.get(`/api/record/findByActivityIdWithData/${activityId}`)
  },
  
  // 导出成绩
  exportRecords(params) {
    return request({
      url: '/api/record/exportRecords',
      method: 'get',
      params,
      responseType: 'blob' // 导出文件需指定响应类型为blob
    });
  },
}